module.exports = __webpack_public_path__ + "static/img/perecent6.8cae660c.png";